import { IHttpApi } from '@cian/http-api/shared';

import { isResponseContainsKey } from './helpers';
import { ILogger } from '@cian/logger';
import { IGetVillageListRequestSchema } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import {
  createGetVillageListModel,
  IGetVillageListResponseError,
  IGetVillageListResponse,
} from '../../node/repositories/countryside-search/v1/get-village-list';

export async function getVillageList(httpApi: IHttpApi, logger: ILogger, parameters: IGetVillageListRequestSchema) {
  try {
    const { response } = await httpApi.fetch(createGetVillageListModel(parameters));

    if (isResponseContainsKey<IGetVillageListResponseError, IGetVillageListResponse>(response, 'errors')) {
      throw response;
    }

    return response;
  } catch (error) {
    logger.error(error, { message: 'Error in getVillageList' });
    throw error;
  }
}
